<template>
  <div class="setting-page">
    <div class="setting-inner">
      <!-- Profile -->
      <section class="setting-card setting-profile" aria-label="Account">
        <div class="setting-profile__avatar-wrap">
          <img
            class="setting-profile__avatar"
            :src="$store.state.authUser.gender === 'female' ? 'https://storage.googleapis.com/spacetech2/mdl/Girl%20Profile%20.png' : 'https://storage.googleapis.com/spacetech2/mdl/Boy%20Profile.png'"
            alt=""
          >
        </div>
        <div class="setting-profile__body">
          <dl class="setting-dl">
            <div class="setting-dl__row">
              <dt class="setting-dl__label">
                {{ $t('setting.name') }}
              </dt>
              <dd class="setting-dl__value">{{ $store.state.authUser.name }}</dd>
            </div>
            <div class="setting-dl__row">
              <dt class="setting-dl__label">
                {{ $t('setting.balance') }}
              </dt>
              <dd class="setting-dl__value setting-dl__value--balance">
                <b>{{ Number($store.state.amount).toLocaleString() }}</b>
                {{ $store.state.language === 'en' ? 'MMK' : 'ကျပ်' }}
              </dd>
            </div>
            <div class="setting-dl__row">
              <dt class="setting-dl__label">
                {{ $t('setting.phone') }}
              </dt>
              <dd class="setting-dl__value">{{ $store.state.authUser.phone }}</dd>
            </div>
            <div v-if="$store.state.authUser.commissioner" class="setting-dl__row">
              <dt class="setting-dl__label">
                {{ $store.state.language === 'en' ? 'Upper Line' : 'အထက်အေးဂျင့်' }}
              </dt>
              <dd class="setting-dl__value">{{ $store.state.authUser.commissioner }}</dd>
            </div>
          </dl>
        </div>
      </section>

      <!-- Quick actions -->
      <section class="setting-card setting-quick" aria-label="Shortcuts">
        <h2 class="setting-section-title">
          {{ $t('setting.section_shortcuts') }}
        </h2>
        <div class="setting-quick__grid">
          <button type="button" class="setting-quick__btn" @click="$router.push('/deposit')">
            <span class="setting-quick__icon-wrap">
              <img src="https://storage.googleapis.com/spacetech2/mdl/deposit%20(4).png" alt="" class="setting-quick__icon">
            </span>
            <span class="setting-quick__label">{{ $t('setting.deposit') }}</span>
          </button>
          <button type="button" class="setting-quick__btn" @click="$router.push('/withdraw')">
            <span class="setting-quick__icon-wrap">
              <img src="https://storage.googleapis.com/spacetech2/mdl/withdraw%20(2).png" alt="" class="setting-quick__icon">
            </span>
            <span class="setting-quick__label">{{ $t('setting.withdraw') }}</span>
          </button>
          <button type="button" class="setting-quick__btn" @click="$router.push('/history')">
            <span class="setting-quick__icon-wrap">
              <img src="https://storage.googleapis.com/spacetech2/mdl/testing.png" alt="" class="setting-quick__icon">
            </span>
            <span class="setting-quick__label">{{ $t('setting.transaction') }}</span>
          </button>
          <button type="button" class="setting-quick__btn" @click="$router.push('/betslip-history')">
            <span class="setting-quick__icon-wrap">
              <img src="https://storage.googleapis.com/spacetech2/mdl/report.png" alt="" class="setting-quick__icon">
            </span>
            <span class="setting-quick__label">{{ $t('setting.voucher') }}</span>
          </button>
        </div>
      </section>

      <!-- Menu -->
      <section class="setting-card setting-menu-card" aria-label="Settings">
        <h2 class="setting-section-title">
          {{ $t('setting.section_account') }}
        </h2>
        <ul class="setting-menu">
          <li class="setting-menu__item setting-menu__item--static">
            <div class="setting-menu__row">
              <span class="setting-menu__icon"><i class="fas fa-user"></i></span>
              <span class="setting-menu__text">{{
                $store.state.language === 'en'
                  ? `Nickname — ${$store.state.authUser.user_name || '—'}`
                  : `အမည်ပြောင် — ${$store.state.authUser.user_name || '—'}`
              }}</span>
            </div>
          </li>

          <li
            class="setting-menu__item"
            data-toggle="modal"
            data-target="#editUserPassword"
          >
            <div class="setting-menu__row setting-menu__row--action">
              <span class="setting-menu__icon"><i class="fas fa-key"></i></span>
              <span class="setting-menu__text">{{
                $store.state.language === 'en' ? 'Change password' : 'လျှို့ဝှက်နံပါတ် ပြောင်းမည်'
              }}</span>
              <i class="fas fa-chevron-right setting-menu__chev"></i>
            </div>
          </li>

          <li
            v-if="!$store.state.authUser.commissioner"
            class="setting-menu__item"
            data-toggle="modal"
            data-target="#editUserInvitationCode"
          >
            <div class="setting-menu__row setting-menu__row--action">
              <span class="setting-menu__icon"><i class="fas fa-code"></i></span>
              <span class="setting-menu__text">{{
                $store.state.language === 'en' ? 'Update agent code' : 'မိတ်ဆက်ကုဒ် ပြောင်းမည်။'
              }}</span>
              <i class="fas fa-chevron-right setting-menu__chev"></i>
            </div>
          </li>

          <li class="setting-menu__item" @click="() => $router.push('/rule')">
            <div class="setting-menu__row setting-menu__row--action">
              <span class="setting-menu__icon"><i class="fas fa-book"></i></span>
              <span class="setting-menu__text">{{
                $store.state.language === 'en' ? 'Rules' : 'စည်းကမ်းချက်များ'
              }}</span>
              <i class="fas fa-chevron-right setting-menu__chev"></i>
            </div>
          </li>

          <li class="setting-menu__item setting-menu__item--dropdown">
            <div class="dropdown w-100">
              <div
                class="setting-menu__row setting-menu__row--action"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                id="setting-navbar-language"
              >
                <span class="setting-menu__icon"><i class="fas fa-language"></i></span>
                <span class="setting-menu__text">{{
                  $store.state.language === 'en' ? 'Language' : 'ဘာသာစကား ပြောင်းမည်'
                }}</span>
                <i class="fas fa-chevron-right setting-menu__chev"></i>
              </div>
              <div class="dropdown-menu dropdown-menu-right setting-lang-menu" aria-labelledby="setting-navbar-language">
                <button type="button" class="dropdown-item setting-lang-item" @click="setLangLocalstorage('en')">
                  <img
                    src="https://cdn.myanmarsoccer.xyz/build/assets/img/icons/common/united-kingdom.png"
                    alt=""
                    class="setting-lang-flag"
                  >
                  {{ $store.state.language === 'en' ? 'English' : 'အဂ်လိပ်စာ' }}
                </button>
                <div class="dropdown-divider setting-lang-divider"></div>
                <button type="button" class="dropdown-item setting-lang-item" @click="setLangLocalstorage('mm')">
                  <img
                    src="https://cdn.myanmarsoccer.xyz/build/assets/img/icons/common/myanmar.png"
                    alt=""
                    class="setting-lang-flag"
                  >
                  {{
                    $store.state.language === 'en' ? 'Myanmar (Burmese)' : 'မြန်မာ (ဗမာစာ)'
                  }}
                </button>
              </div>
            </div>
          </li>
        </ul>

        <div class="setting-menu__logout-wrap">
          <button type="button" class="setting-logout" @click="logout">
            <i class="ni ni-lock-circle-open setting-logout__icon"></i>
            <span>{{ $t('setting.logout') }}</span>
          </button>
        </div>
      </section>
    </div>

    <!-- Password modal -->
    <div
      class="modal fade"
      id="editUserPassword"
      tabindex="-1"
      role="dialog"
      aria-labelledby="editUserPasswordLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-sm" role="document">
        <div class="modal-content setting-modal">
          <div class="modal-header setting-modal__header">
            <h5 id="editUserPasswordLabel" class="modal-title setting-modal__title">
              {{ $t('setting.update_password') }}
            </h5>
            <button type="button" class="close setting-modal__close text-white" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body setting-modal__body">
            <div class="form-group setting-field">
              <label class="setting-field__label">{{ $t('setting.old_password') }}</label>
              <input class="form-control setting-input" v-model="password.old" type="password" autocomplete="current-password">
              <span class="text-danger small">{{ errors.old }}</span>
            </div>
            <div class="form-group setting-field">
              <label class="setting-field__label">{{ $t('setting.new_password') }}</label>
              <input class="form-control setting-input" v-model="password.new" type="password" autocomplete="new-password">
              <span class="text-danger small">{{ errors.new }}</span>
            </div>
            <div class="form-group setting-field">
              <label class="setting-field__label">{{ $t('setting.confirm_password') }}</label>
              <input class="form-control setting-input" v-model="password.confirm" type="password" autocomplete="new-password">
              <span class="text-danger small">{{ errors.confirm || errors.confirmPassword }}</span>
            </div>
            <button type="button" class="btn setting-modal__submit btn-block" @click="changeNewPassword">
              <div v-if="!isConfirm">
                {{ $t('setting.update') }}
              </div>
              <Loading v-if="isConfirm" color="#ffffff" size="24" class="py-0" />
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Invitation code modal -->
    <div
      class="modal fade"
      id="editUserInvitationCode"
      tabindex="-1"
      role="dialog"
      aria-labelledby="editUserInvitationCodeLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-sm" role="document">
        <div class="modal-content setting-modal">
          <div class="modal-header setting-modal__header">
            <h5 id="editUserInvitationCodeLabel" class="modal-title setting-modal__title">
              {{ $store.state.language === 'en' ? 'Update agent code' : 'မိတ်ဆက်ကုဒ် ပြောင်းမည်။' }}
            </h5>
            <button type="button" class="close setting-modal__close text-white" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body setting-modal__body">
            <div class="form-group setting-field">
              <label class="setting-field__label">{{
                $store.state.language === 'en' ? 'Invitation code' : 'မိတ်ဆက် ကုဒ်ထည့်ပါ။'
              }}</label>
              <input class="form-control setting-input" v-model="code.currentCode" type="text" autocomplete="off">
              <span class="text-danger small">{{ errors.currentCode ?? error }}</span>
            </div>
            <button type="button" class="btn setting-modal__submit btn-block" @click="updateInviteCode">
              <div v-if="!isConfirm">
                {{ $t('setting.update') }}
              </div>
              <Loading v-if="isConfirm" color="#ffffff" size="24" class="py-0" />
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Toast, Dialog, Loading } from 'vant';
import { mapActions } from 'vuex';

export default {
  components: { Loading },
  data() {
    return {
      password: {
        user_id: this.$store.state.authUser.id,
      },
      code: {
        currentCode: '',
      },
      isConfirm: false,
      errors: {},
      error: '',
    };
  },
  methods: {
    ...mapActions(['logoutUser', 'fetchUser']),
    setLangLocalstorage(language) {
      localStorage.setItem('language', language);
      this.$store.commit('setLanguage', language);
    },
    updateInviteCode() {
      this.errors = {};
      if (!this.code.currentCode) {
        this.errors.currentCode =
          this.$store.state.language === 'en'
            ? 'Agent Code required'
            : 'မိတ်ဆက် ကုဒ်ထည့်ပါ။';
        return false;
      }
      this.isConfirm = true;
      Dialog.confirm({
        title:
          this.$store.state.language === 'en'
            ? 'Are you sure?'
            : 'သေချာပါသလား?',
        cancelButtonText:
          this.$store.state.language === 'en' ? 'Cancel' : 'မလုပ်တော့ပါ။',
        confirmButtonText:
          this.$store.state.language === 'en' ? 'Sure' : 'သေချာပြီ။',
      })
        .then(() => {
          this.updateUserInvitationCode();
        })
        .catch(() => {});
      this.isConfirm = false;
      return true;
    },
    async updateUserInvitationCode() {
      try {
        await axios.post(
          '/auth/userInvitationCodeUpdate',
          this.code,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
          }
        );
        Toast.success(
          this.$store.state.language === 'en' ? 'Success' : 'အောင်မြင်သည်။'
        );
        this.code = {};
        this.errors = {};
        $('#editUserInvitationCode').modal('hide');
        this.fetchUser();
      } catch (error) {
        if (error.response && error.response.data) {
          const responseErrors = error.response.data.errors;
          if (responseErrors.code) {
            this.error = responseErrors.code[0];
          }
        }
      }
    },
    changeNewPassword() {
      this.errors = {};
      if (!this.password.old) {
        this.errors.old =
          this.$store.state.language === 'en'
            ? 'Old password required'
            : 'လျို့ဝှက်နံပါတ်အဟောင်း ထည့်ပါ။';
        return false;
      }
      if (!this.password.new) {
        this.errors.new =
          this.$store.state.language === 'en'
            ? 'New password required'
            : 'လျို့ဝှက်နံပါတ်အသစ် ထည့်ပါ။';
        return false;
      }
      if (!this.password.confirm) {
        this.errors.confirm =
          this.$store.state.language === 'en'
            ? 'Confirm password required'
            : 'အတည်ပြုလျို့ဝှက်နံပါတ် ထည့်ပါ။';
        return false;
      }
      if (this.password.new !== this.password.confirm) {
        this.errors.confirmPassword =
          this.$store.state.language === 'en'
            ? 'New passwords not match'
            : 'လျှို့ဝှက်နံပါတ် မတူညီပါ။';
        return false;
      }
      this.isConfirm = true;
      Dialog.confirm({
        title:
          this.$store.state.language === 'en'
            ? 'Are you sure?'
            : 'သေချာပါသလား?',
        cancelButtonText:
          this.$store.state.language === 'en' ? 'Cancel' : 'မလုပ်တော့ပါ။',
        confirmButtonText:
          this.$store.state.language === 'en' ? 'Sure' : 'သေချာပြီ။',
      })
        .then(() => {
          this.updateUser();
        })
        .catch(() => {});
      this.isConfirm = false;
      return true;
    },
    async updateUser() {
      try {
        await axios.post(
          '/auth/userPasswordChange',
          this.password,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
          }
        );
        Toast.success(
          this.$store.state.language === 'en' ? 'Success' : 'အောင်မြင်သည်။'
        );
        this.password = { user_id: this.$store.state.authUser.id };
        this.errors = {};
        $('#editUserPassword').modal('hide');
      } catch (error) {
        Toast.fail(
          this.$store.state.language === 'en' ? 'Fail' : 'ကျရှုံးသည်။'
        );
      }
    },
    logout() {
      Dialog.confirm({
        title:
          this.$store.state.language === 'en'
            ? 'Are you sure to log out?'
            : 'ထွက်မှာ သေချာပါသလား?',
        cancelButtonText:
          this.$store.state.language === 'en' ? 'Cancel' : 'မထွက်တော့ပါ',
        confirmButtonText:
          this.$store.state.language === 'en' ? 'Sure' : 'သေချာပြီ',
      })
        .then(async () => {
          await this.logoutUser();
          this.$router.push('/auth/login');
          Toast.success(
            this.$store.state.language === 'en' ? 'Logged out!' : 'ထွက်ပြီးပြီ'
          );
        })
        .catch(() => {});
    },
  },
  async mounted() {
    const authUser = await this.fetchUser();
    if (!authUser) {
      this.$router.push('/auth/login');
    }
    if (authUser && !authUser.is_verified) {
      this.$router.push('/auth/verify');
    }
  },
};
</script>
<style scoped>
.setting-page {
  min-height: 100vh;
  padding: 1rem 0.75rem 1.25rem;
  padding-bottom: calc(1.25rem + env(safe-area-inset-bottom, 0px));
  background-color: #0d0e12;
  background-image: linear-gradient(180deg, rgba(13, 14, 18, 0.92) 0%, rgba(13, 14, 18, 0.88) 100%),
    url('https://storage.googleapis.com/spacetech2/mdl/bg.png');
  background-size: cover;
  background-position: center top;
  background-attachment: scroll;
  -webkit-overflow-scrolling: touch;
}

.setting-inner {
  max-width: 32rem;
  margin: 0 auto;
}

.setting-card {
  background: #1d1f26;
  border: none;
  border-radius: 14px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.35);
  margin-bottom: 1rem;
  overflow: hidden;
}

.setting-section-title {
  color: #e8eaef;
  font-size: 0.8125rem;
  font-weight: 700;
  letter-spacing: 0.02em;
  margin: 0;
  padding: 0.85rem 1rem 0.35rem;
  text-transform: uppercase;
}

/* Profile */
.setting-profile {
  display: flex;
  gap: 1rem;
  align-items: flex-start;
  padding: 1.1rem 1rem 1.15rem;
}

.setting-profile__avatar-wrap {
  flex-shrink: 0;
  padding: 3px;
  border-radius: 16px;
  background: linear-gradient(145deg, rgba(92, 152, 255, 0.45), rgba(92, 152, 255, 0.08));
}

.setting-profile__avatar {
  display: block;
  width: 4.5rem;
  height: 4.5rem;
  border-radius: 13px;
  object-fit: cover;
  background: #2a2d36;
}

.setting-profile__body {
  flex: 1;
  min-width: 0;
}

.setting-dl {
  margin: 0;
}

.setting-dl__row {
  display: flex;
  gap: 0.5rem;
  align-items: baseline;
  padding: 0.35rem 0;
}

.setting-dl__row:last-child {
  padding-bottom: 0;
}

.setting-dl__label {
  color: #8b95a8;
  flex: 0 0 5.5rem;
  font-size: 0.75rem;
  font-weight: 600;
  margin: 0;
}

.setting-dl__value {
  color: #f0f2f5;
  font-size: 0.875rem;
  margin: 0;
  text-align: right;
  flex: 1;
  word-break: break-word;
}

.setting-dl__value--balance b {
  color: #efdb01;
  font-weight: 700;
}

/* Quick grid */
.setting-quick {
  padding-bottom: 0.35rem;
}

.setting-quick__grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 0.5rem;
  padding: 0.35rem 0.65rem 1rem;
}

.setting-quick__btn {
  -webkit-tap-highlight-color: transparent;
  background: #252830;
  border: none;
  border-radius: 12px;
  color: #e8eaef;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.35rem;
  min-height: 4.25rem;
  padding: 0.5rem 0.25rem;
  transition: background 0.15s ease, transform 0.1s ease;
}

.setting-quick__btn:active {
  transform: scale(0.97);
  background: #2f3440;
}

.setting-quick__icon-wrap {
  align-items: center;
  display: flex;
  height: 2rem;
  justify-content: center;
  width: 100%;
}

.setting-quick__icon {
  height: 1.5rem;
  width: 1.5rem;
  object-fit: contain;
}

.setting-quick__label {
  font-size: 0.625rem;
  font-weight: 600;
  line-height: 1.2;
  text-align: center;
}

/* Menu */
.setting-menu-card {
  padding-bottom: 0.5rem;
}

.setting-menu {
  list-style: none;
  margin: 0;
  padding: 0 0.5rem 0.5rem;
}

.setting-menu__item {
  border-radius: 10px;
  margin-bottom: 2px;
}

.setting-menu__item--static .setting-menu__row {
  cursor: default;
  opacity: 0.95;
}

.setting-menu__item:not(.setting-menu__item--static):not(.setting-menu__item--dropdown) {
  cursor: pointer;
  transition: background 0.15s ease;
}

.setting-menu__item:not(.setting-menu__item--static):not(.setting-menu__item--dropdown):hover {
  background: rgba(255, 255, 255, 0.04);
}

.setting-menu__item:not(.setting-menu__item--static):not(.setting-menu__item--dropdown):active {
  background: rgba(255, 255, 255, 0.07);
}

.setting-menu__row {
  align-items: center;
  display: flex;
  gap: 0.65rem;
  min-height: 3rem;
  padding: 0.5rem 0.65rem;
}

.setting-menu__row--action {
  cursor: pointer;
}

.setting-menu__icon {
  align-items: center;
  color: #93a1c0;
  display: flex;
  font-size: 1.05rem;
  justify-content: center;
  width: 1.5rem;
}

.setting-menu__text {
  color: #f0f2f5;
  flex: 1;
  font-size: 0.9rem;
  font-weight: 500;
  text-align: left;
}

.setting-menu__chev {
  color: #5c6478;
  font-size: 0.7rem;
}

.setting-menu__item--dropdown .setting-menu__row--action {
  margin: 0;
}

.setting-menu__item--dropdown .dropdown.show .setting-menu__chev {
  transform: rotate(90deg);
}

.setting-menu__chev {
  transition: transform 0.2s ease;
}

.setting-lang-menu {
  background: #252830;
  border: none;
  border-radius: 10px;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.45);
  margin-top: 0.35rem;
  padding: 0.35rem 0;
}

.setting-lang-item {
  align-items: center;
  color: #e8eaef !important;
  display: flex;
  font-size: 0.9rem;
  gap: 0.5rem;
  padding: 0.55rem 1rem;
}

.setting-lang-item:hover,
.setting-lang-item:focus {
  background: rgba(92, 152, 255, 0.12) !important;
  color: #fff !important;
}

.setting-lang-flag {
  height: 1.15rem;
  width: 1.15rem;
  object-fit: contain;
}

.setting-lang-divider {
  border: none;
  height: 0;
  margin: 0.35rem 0;
  overflow: hidden;
}

.setting-menu__logout-wrap {
  padding: 0.5rem 0.75rem 0.85rem;
}

.setting-logout {
  -webkit-tap-highlight-color: transparent;
  align-items: center;
  background: rgba(220, 53, 69, 0.12);
  border: none;
  border-radius: 12px;
  color: #ff6b7a;
  cursor: pointer;
  display: flex;
  font-size: 0.9rem;
  font-weight: 600;
  gap: 0.6rem;
  justify-content: center;
  min-height: 3rem;
  padding: 0.65rem 1rem;
  transition: background 0.15s ease;
  width: 100%;
}

.setting-logout:hover {
  background: rgba(220, 53, 69, 0.2);
  color: #ff8a96;
}

.setting-logout__icon {
  font-size: 1.15rem;
}

/* Modals (class on modal-content; dialog may be in body — use deep) */
.setting-modal {
  background: #1d1f26 !important;
  border: none !important;
  border-radius: 14px !important;
  overflow: hidden;
}

.setting-modal__header {
  align-items: center;
  border-bottom: none !important;
  padding: 0.85rem 1rem !important;
}

.setting-modal__title {
  color: #f0f2f5 !important;
  font-size: 1rem !important;
  font-weight: 600 !important;
}

.setting-modal__close {
  opacity: 0.75;
  text-shadow: none;
}

.setting-modal__body {
  padding: 1.15rem 1.1rem 1.25rem !important;
}

.setting-field__label {
  color: #8b95a8;
  display: block;
  font-size: 0.8rem;
  font-weight: 600;
  margin-bottom: 0.35rem;
}

.setting-input {
  background: #252830 !important;
  border: none !important;
  border-radius: 10px !important;
  color: #f0f2f5 !important;
  font-size: 0.9rem !important;
  padding: 0.55rem 0.75rem !important;
}

.setting-input:focus {
  box-shadow: 0 0 0 2px rgba(92, 152, 255, 0.45) !important;
  outline: none !important;
}

.setting-modal__submit {
  background: linear-gradient(180deg, #6a9fff 0%, #5c98ff 100%);
  border: none;
  border-radius: 10px;
  color: #fff !important;
  font-weight: 600;
  margin-top: 0.5rem;
  padding: 0.65rem 1rem;
}

.setting-modal__submit:hover {
  filter: brightness(1.06);
  color: #fff !important;
}

.error {
  margin-bottom: 13px;
  height: 40px;
  display: flex;
  align-items: center;
  color: red;
  border: 1px solid red;
  border-radius: 8px;
  padding: 0px 15px;
  background: #ff000014;
  font-weight: bold;
}

@media (max-width: 360px) {
  .setting-quick__label {
    font-size: 0.5625rem;
  }
  .setting-dl__label {
    flex-basis: 4.75rem;
  }
}
</style>
